var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 142,
    viewBox: "0 0 546 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 142C51.8381 136.247 162.563 109.154 190.76 46.8103H135.109L273 0L410.891 46.8103H355.24C383.437 109.154 494.162 136.247 546 142H273H0Z",
    fill: "url(#paint0_linear_63_1842)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_1842",
    x1: 273,
    y1: 125.901,
    x2: 273,
    y2: 17.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroArrow);
export default __webpack_public_path__ + "static/media/intro_arrow.1442ae3fa0f05f22bff22c58a651c92e.svg";
export { ForwardRef as ReactComponent };